import { FieldBorderStyle } from '../enums/GameEnums';
import { betStatus } from '../enums/BetStatus';
import { gameStore } from '../module/store/gameStore';
import { resultStore } from '../module/store/resultStore';

export const detectFieldColor = (index) => {
  const { betResult, cashOutResult } = resultStore;
  const { doSpinState, resultReportState } = gameStore
  if(!resultReportState && !doSpinState) return FieldBorderStyle.none

  if ( betResult?.status !== betStatus.lose ) {
    return index === betResult?.step ? FieldBorderStyle.current : index >= betResult?.step ? FieldBorderStyle.none : FieldBorderStyle.win;
  } else if (cashOutResult) {
    return index < betResult?.step ? FieldBorderStyle.win : FieldBorderStyle.none;
  }
  return FieldBorderStyle.lose;
};